import React, { useEffect, useState } from 'react';
import { KFLButton, KFLDialog, KFLInput } from '@kamstrup/kamstrup-frontend-library';
import DialogHeader from '../../shared/dialog/dialogHeader';
import Translate from '../../shared/localization/localize';
import DialogSection from '../../shared/dialog/dialogSection';
import {
  TransferDialogs,
  TransferStatus,
} from '../../../modules/dialogs/transfer';
import TransferSummary from './transferSummary';
import Scrim from '../../shared/scrim';
import * as m from '../../../modules/dialogs/transfer/messages';
import DialogFooter from '../../shared/dialog/dialogFooter';
import useTxSend from '../../../modules/dialogs/transfer/useTxSend';
import useLocale from '../../../hooks/useLocale';
import SandwichBox from '../../shared/sandwichBox';

const TxDialogSendCheck: React.FC = () => {
  const [userCode, setUserCode] = useState('');
  const { translate } = useLocale();
  const {
    tx,
    validate,
    validateStatus,
    getCode,
    getCodeStatus,
    checkCode,
    checkCodeStatus,
    closePanel,
    changeScreen,
  } = useTxSend();

  useEffect(() => validate(), []);

  const isReadyToTransfer =
    tx.id && tx.status === TransferStatus.CODE_REQUESTED && userCode
      ? true
      : false;

  const spinnerIsActive =
    //validateStatus.isFetching ||
    getCodeStatus.isFetching ||
    checkCodeStatus.isFetching;

  const spinnerLabel = 
  //validateStatus.isFetching
  //  ? m.msgValidating
    //: 
    getCodeStatus.isFetching
    ? m.msgGettingCode
    : checkCodeStatus.isFetching
    ? m.msgCheckingCode
    : undefined;

  const content = (
    <DialogSection isMain scrollable>
      <Scrim
        isActive={validateStatus.isFetching}
        label={m.msgValidating}
        iconSize={16}
        fullHeight
      >
        <SandwichBox
          bottom_bun={
            <SandwichBox>
              <Scrim
                isActive={spinnerIsActive}
                label={spinnerLabel}
                iconSize={16}
              >
                {!validateStatus.isFetching && validateStatus.errorMsg && (
                  <p className="error">{translate(validateStatus.errorMsg)}</p>
                )}
                {tx.status === TransferStatus.VALIDATED && (
                  <div className="tx_send_getcode_box">
                    {getCodeStatus.isFetching ? (
                      <></>
                    ) : (
                      <>                        
                        <KFLButton id="dg-tx-send-bt-getcode" onClick={getCode}>
                          {translate(m.msgBtnGetCode)}
                        </KFLButton>
                        <p>{translate(m.msgGetCodeHelper)}</p>
                      </>
                    )}
                  </div>
                )}
                {tx.status === TransferStatus.CODE_REQUESTED && (
                  <div className="tx_send_checkcode_box">
                    <KFLInput
                      id="tx-send-tb-code"
                      value={userCode}
                      onChange={setUserCode}
                      label={translate(m.msgCodeLabel)}
                    ></KFLInput>
                    <p>{translate(checkCodeStatus.errorMsg)}</p>
                    <KFLButton
                      id="dg-tx-send-bt-newcode"
                      onClick={getCode}
                      variant="borderless"
                    >
                      {translate(m.msgCodeResend)}
                    </KFLButton>
                  </div>
                )}
              </Scrim>
            </SandwichBox>
          }
        >
          <TransferSummary transfer={tx}></TransferSummary>
        </SandwichBox>
      </Scrim>
    </DialogSection>
  );

  const sendNowBtn = (
    <KFLButton
      id="dg-tx-send-bt-finish"
      key="dg-tx-send-bt-finish"
      onClick={() => checkCode(userCode)}
      disabled={!isReadyToTransfer}
    >
      {translate(m.msgSendNowBtn)}
    </KFLButton>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={m.msgHeaderSend} />}
          fnCloseDialog={closePanel}
          fnBackDialog={() => changeScreen(TransferDialogs.SEND)}
        />
      }
      sections={[content]}
      footer={
        <DialogFooter
          leftContent={''}
          buttons={[sendNowBtn]}
          hideCancelBtn
          fnCloseDialog={closePanel}
        />
      }
    />
  );
};

export default TxDialogSendCheck;
